import { useQuery } from '@tanstack/react-query';

import {
  type ConnectorFeatureWithProviderOptions,
  connectorService,
} from '@/services/connector-service';
import type { UUID } from '@/utils/uuid';

import { connectorQueryKeys } from './query-keys';

/**
 * Fetch connector features enriched with provider feature options/schema data.
 */
export function useListConnectorFeaturesWithProviderOptions(
  tenantId?: UUID,
  connectorId?: UUID,
  opts?: {
    limit?: number;
    filter?: string;
    enabled?: boolean;
  }
) {
  return useQuery<Array<ConnectorFeatureWithProviderOptions>, Error>({
    queryKey: connectorQueryKeys.featuresWithProviderOptions(
      tenantId,
      connectorId,
      opts?.limit,
      opts?.filter
    ),
    queryFn: async () => {
      if (!tenantId) throw new Error('Missing tenant id');
      if (!connectorId) throw new Error('Missing connector id');

      return connectorService.listConnectorFeaturesWithProviderOptions(
        tenantId,
        connectorId,
        {
          limit: opts?.limit,
          filter: opts?.filter,
        }
      );
    },
    enabled: opts?.enabled ?? (!!tenantId && !!connectorId),
    retry: 3,
    retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
  });
}
